import { AxiosInstance } from 'axios'

export interface ResolveChangeParams {
  uuid: string
  is_resolved: boolean
}

export const resolveChange = async (
  apiClient: AxiosInstance,
  params: ResolveChangeParams
): Promise<ResolveChangeParams> => {
  const { data } = await apiClient.patch(`/v1/change/${params.uuid}/resolve`, {
    is_resolved: params.is_resolved,
  })
  return data
}
